export const inventory = {
      title: 'Inventario',
      subtitle: 'Existencias por producto y por almacén',
      recordsTitle: 'Existencias actuales',
      recordsDescription: 'Consulta las existencias actuales por producto y almacén.',
      adjust: '+ Ajustar inventario',
      editLevels: 'Editar niveles',
      editLevelsTitle: 'Editar niveles de inventario',
      editLevelsSubtitle: 'Configura el inventario mínimo y máximo para este balance.',
      editLevelsSubtitleWithItem: '{{product}} · {{warehouse}}',
      emptyTitle: 'Sin existencias para mostrar',
      emptyDescription: 'No hay registros de inventario para la vista o almacén seleccionados.',
      byProduct: 'Por producto',
      byWarehouse: 'Por almacén',
      warehouse: 'Almacén',
      allWarehouses: 'Todos',
      preferredUnitSwitch: 'Unidad',
      preferredUnitSwitchHint: 'Convierte existencias y niveles a la unidad predeterminada del producto.',
      minimumQuantity: 'Inventario mínimo',
      maximumQuantity: 'Inventario máximo',
      storedValueHint: 'Valor actual guardado: {{quantity}} {{unit}}',
      maximumMustBeGreaterThanMinimum: 'El inventario máximo debe ser mayor o igual al mínimo.',
      totalBoxes: 'Cajas totales',
      productsCount: 'Número de productos',
      state: 'Estado',
      critical: 'Crítico',
      low: 'Bajo',
      overstock: 'Sobre stock',
      ok: 'OK',
    } as const;
